'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M983.058 64c-334.5 253.166-655.302 591.8-655.302 591.8l-231.18-207.8-96.576 98.378c95.016 89.302 315.162 325.198 389.632 413.622 209.59-350.18 427.478-611.336 634.368-850.154l-40.942-45.846z' })
    ));
};